import React, { useContext, useState, useEffect } from "react";
import Graphic from "@arcgis/core/Graphic";
import "../Judumas.css";
import { MapContext } from "../MapContext.js";
import { queryFeaturesOverLimit2k } from "../helpers/helper.js";
import Calendar from "./Calendar.js";
import {
  dayLayer,
  nightLayer,
  hexGrid,
} from "../Services/serviceLayers.js";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import { bikeSensors } from "../Services/serviceAdditionalData.js";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import ContextLayers from "./ContextLayers";

import uniqueValues from "@arcgis/core/smartMapping/statistics/uniqueValues";

import dayActive from "../icons/dienaActive.png";
import dayInactive from "../icons/dienaInactive.png";
import nightActive from "../icons/naktisActive.png";
import nightInactive from "../icons/naktisInactive.png";
import { set } from "date-fns";
import LegendGrid from "./LegendGrid.js";

// Pasiekiamumo elementas, pasirinkus data ir nakti/diena atvaizduojama gride kiek zmoniu tuo metu ten buvo, paspaudus ant hexagono atvaizduojama kur tie zmones atitinkamai buvo diena/nakti ta pacia data.
export default function Grid({ data, token, MapValue }) {
  const mapContext = useContext(MapContext);

  
  const [initialRender, setInitialRender] = useState(0);
  // dienos/ nakties pasirinkimo state
  const [gridSelected, setGridSelected] = useState(null);
  // toggle tarp kontekstiniu duomenu/ pasiekiamumo
  const [gridSidebarSelection, setGridSidebarSelection] = useState(0);
  // paselektinto grido susijusiu (pasiekiamu) gridu duomenys
  const [gridData, setGridData] = useState([]);
  // visi gridai is hexGrid layerio
  const [gridObjArr, setGridObjArr] = useState([]);
  // flagas isjungti grido teksto matomuma prie mazo zoom lygio
  const [gridTextVisible, setGridTextVisible] = useState(true);
  // galimos kalendoriaus datos
  const [calendarDates, setCalendarDates] = useState([]);
  // kontekstiniai duomenys - Palikti nes pazymeti kontekstinia layeriai sitam lange turi buti ijungti by default
  const [gridToggleArr, setGridToggleArr] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);

  const[againstGridObjArr, setAgainstGridObjArr] = useState([])

  const[applicationFeatureLayer, setApplicationFeatureLayer] = useState(null)

  const[initialFetureLayer, setInitialFetureLayer] = useState(null)


  // grafinis layeris atvaizduoti gridam
  // grafinis layeris vietoj feature layerio yra naudojamas todel , kad paspaudus grid'a reikia "rankiniu" budu suskaiciuti kurie useriu id'ai kuriame gride buvo, ir tada tuos gridus su labelint,
  // kadangi feature layeri nera saugoma informacija apie userius pagal data (reiktu saugoti rysi su kiekvienu kitu gridu ir jo useriais tam tikra diena + geometrija) 
  // todel tu duoemnu paspaudus grid'a negalima sukisti i rendererinimo taisykles. 
  // Nebent pabandyciau deti kaip arr[id, kiekis] -> renderio funkcijoi kazkaip sutikrinti pagal id kieki ir paziureti ar galima tada. Manau verta bus paziureti.
  let hexGraphicLayer = new GraphicsLayer();
  


  //mapContext.state.mapView.map.add(clientFeatureLayer);
  const [graphicLayer, setGraphicLayer] = useState(hexGraphicLayer);

  // kaip kontekstinuose duomenyse layeriu atvaizdavimo taisykles linijos zemiau - taskai auksciau 
  const lowListLayerUrs = [
    "https://arcgis.sisp.lt/arcgis/rest/services/VT/VT_marsutu_trasos/FeatureServer",
    "https://gis.vplanas.lt/arcgis/rest/services/Interaktyvus_zemelapis/Transportas/MapServer",
  ];

  function waitForElm(selector) {
    return new Promise((resolve) => {
      if (document.querySelector(selector)) {
        return resolve(document.querySelectorAll(selector));
      }

      const observer = new MutationObserver((mutations) => {
        if (document.querySelector(selector)) {
          resolve(document.querySelectorAll(selector));
          observer.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    });
  }

  const mergeArrays = (arr1, arr2) => {
    return arr1.reduce((acc, b) => {
      const idx = acc.findIndex((item) => item.gridId === b.gridId); //look for the acc has the same id while iterating array1
      if (idx > -1) {
        // if found need to merge with value of array2
        acc[idx] = Object.assign(b, acc[idx]);
        return acc;
      }
      return [...acc]; //if we don't find anything so "b" is an unique entry
    }, arr2); //inital values of reduce is from array2
  };

  // grido arrayui pridedama geometrija prie atitinkamu gridu
  function addGeometryToData(gridArray, geometryArray) {
    geometryArray.forEach((elementGeo) => {
      gridArray.forEach((elementGrid) => {
        if (elementGrid.gridId === elementGeo.attributes.grid_id) {
          elementGrid.geometry = elementGeo.geometry;
        }
      });
    });

    return gridArray;
  }

  // gaunama gridu geometrija ir iskvieciamas metodas ja prideti prie gridu arrayaus
  async function getGridGeometry(gridArray) {
    //console.log()
    let queryWhere = "grid_id IN ('";
    let query = hexGrid.createQuery();
    let gridGeometryObjArray = [];
    let i = 0;
    gridArray.forEach(async (gridObj) => {
      queryWhere += gridObj.gridId + "'";
      i++;
      if (i === 500) {
        queryWhere += ")";
        i = 0;
        query = queryWhere;
        try {
          let requestGrids = await hexGrid.queryFeatures(query);
          gridGeometryObjArray = [
            ...gridGeometryObjArray,
            ...addGeometryToData(gridArray, requestGrids.features),
          ];
        } catch (err) {
          console.error("queryFeatures failed", err);
        }
        queryWhere = "grid_id IN ('";
      } else {
        queryWhere += ",'";
      }
    });
    queryWhere = queryWhere.slice(0, -2);
    queryWhere += ")";
    try{
      query.where = queryWhere;
    }
    catch (error) {
      console.error("Failed to form rid query", error);
    }

    try {
      let requestGrids = await hexGrid.queryFeatures(query);
      gridGeometryObjArray = [
        ...gridGeometryObjArray,
        ...addGeometryToData(gridArray, requestGrids.features),
      ];
    } catch (err) {
      console.error("queryFeatures failed", err);
    }

    //console.log("GRID GOOD")
    return gridGeometryObjArray;
  }


  // Sukurti feature Layeri gridui
  function createFeatureLayer() {
    // Check if Empty Hex Grid layer already exists
    let existingLayer = null;
    mapContext.state.mapView.map.layers.forEach((layer) => {
      if (layer.title === "Empty Hex Grid") {
        existingLayer = layer;
      }
    });

    // If layer exists, just make it visible
    if (existingLayer) {
      existingLayer.visible = true;
      setApplicationFeatureLayer(existingLayer);
      setInitialFetureLayer(existingLayer);
     //console.log("Empty Hex Grid layer already exists, making it visible");
      return;
    }

    // If layer doesn't exist, create it
    const fields = [
      {
        name: "ObjectID",
        alias: "ObjectID",
        type: "oid"
      },
      {
        name: "grid_id",
        alias: "Grid ID",
        type: "string"
      },
      {
        name: "f_kiekis",
        alias: "Frequency",
        type: "integer"
      },
      {
        name: "f_sarasas1",
        alias: "User List",
        type: "string"
      },
      {
        name: "f_sarasas2",
        alias: "User List",
        type: "string"
      },
      {
        name: "f_sarasas3",
        alias: "User List",
        type: "string"
      },
      {
        name: "f_sarasas4",
        alias: "User List",
        type: "string"
      }
    ];

    let query = hexGrid.createQuery();
    query.where = "1=1";

    queryFeaturesOverLimit2k(hexGrid, query, mapContext).then((results) => {
        const graphics = results.map((feature, index) => {
          //console.log(feature.attributes.grid_id)
          return new Graphic({
            geometry: feature.geometry,
            attributes: {
              ObjectID: index + 1, // you need a unique ObjectID
              grid_id: feature.attributes.grid_id,
              f_kiekis: null,
              f_sarasas1: "",
              f_sarasas2: "",
              f_sarasas3: "",
              f_sarasas4: ""
            }
          });
        });

       //console.log(graphics)
        const hexLayer = new FeatureLayer({
        source: graphics,
        objectIdField: "ObjectID",
        visible: false,
        fields: fields,
        geometryType: "polygon",
        spatialReference: { wkid: 3857 }, // or match your map's spatial reference
        renderer: {
          type: "simple", // simple fill with outline only
          symbol: {
            type: "simple-fill",
            style: "none",
            color: [0, 0, 0, 0], // transparent fill
            outline: {
              color: "gray",
              width: 1
            }
          }
        },
        title: "Empty Hex Grid"
      });

     //console.log("Feature Layer created");
      try {
        mapContext.state.mapView.map.add(hexLayer);
        setApplicationFeatureLayer(hexLayer);
        setInitialFetureLayer(hexLayer);
      } catch (error) {
        console.error("Error adding hex layer:", error);
      }

    });

    // Create the graphics array (maybe from a query or table join)


  }

  // Sudeti atributus i featuer layeri
  function populateFeatureLayerAttributes(results) {
    //console.log(results)
    if (!applicationFeatureLayer) return;

    // Dispatch before creating Correlation Grid layer
    

      // Step 1: Build lookup table from query results
      const dayDataMap = new Map();
      results.forEach((feature) => {
        const attrs = feature.attributes;
        dayDataMap.set(attrs.grid_id, {
          f_kiekis: attrs.f_kiekis,
          f_sarasas1: attrs.f_sarasas1,
          f_sarasas2: attrs.f_sarasas2,
          f_sarasas3: attrs.f_sarasas3,
          f_sarasas4: attrs.f_sarasas4
        });
      });

      //console.log(dayDataMap)
      // Step 2: Update matching graphics in the client layer
      applicationFeatureLayer.source.items.forEach((graphic) => {
        const gridId = graphic.attributes.grid_id;
        const match = dayDataMap.get(gridId);

        if (match) {
          //console.log("update", graphic.attributes)
          graphic.attributes.f_kiekis = match.f_kiekis;
          graphic.attributes.f_sarasas1 = match.f_sarasas1;
          graphic.attributes.f_sarasas2 = match.f_sarasas2;
          graphic.attributes.f_sarasas3 = match.f_sarasas3;
          graphic.attributes.f_sarasas4 = match.f_sarasas4;
        } else {
          graphic.attributes.f_kiekis = null;
          graphic.attributes.f_sarasas1 = "";
          graphic.attributes.f_sarasas2 = "";
          graphic.attributes.f_sarasas3 = "";
          graphic.attributes.f_sarasas4 = "";
        }
      });


      const updatedGraphics = applicationFeatureLayer.source.items.map((g) => {
        const gridId = g.attributes.grid_id;
        const updated = dayDataMap.get(gridId);

        return new Graphic({
          geometry: g.geometry,
          attributes: {
            ObjectID: g.attributes.ObjectID,
            grid_id: gridId,
            f_kiekis: updated?.f_kiekis ?? null,
            f_sarasas1: updated?.f_sarasas1 ?? "",
            f_sarasas2: updated?.f_sarasas2 ?? "",
            f_sarasas3: updated?.f_sarasas3 ?? "",
            f_sarasas4: updated?.f_sarasas4 ?? ""
          }
        });
      });

      const maxUsage = Math.max(
        ...updatedGraphics.map((g) => g.attributes.f_kiekis || 0)
      );

      if (gridSelected === 0) {
        mapContext.dispatch({
          gridLegendData: ["Day", maxUsage ],
        });
      } else if (gridSelected === 1) {
        mapContext.dispatch({
          gridLegendData: ["Night", maxUsage ],
        });
      } else {
        mapContext.dispatch({
        gridLegendData: [mapContext.state.gridLegendData[0], maxUsage]
      });

      }
      
      const renderer = buildRenderer(maxUsage, gridSelected === 1);

      const labelingInfo = null
      //const labelingInfo = buildLabelingInfo();

      const newLayer = new FeatureLayer({
      source: updatedGraphics,
      title: "Correlation Grid",
      objectIdField: "ObjectID",
      geometryType: "polygon",
      fields: [
        { name: "ObjectID", type: "oid" },
        { name: "grid_id", type: "string" },
        { name: "f_kiekis", type: "integer" },
        { name: "f_sarasas1", type: "string" },
        { name: "f_sarasas2", type: "string" },
        { name: "f_sarasas3", type: "string" },
        { name: "f_sarasas4", type: "string" }
      ],
      renderer: renderer,
      labelingInfo: labelingInfo,
    });

      // Step 3: If needed, force layer to re-render

    mapContext.state.mapView.map.remove(applicationFeatureLayer);
    setApplicationFeatureLayer(newLayer);
    mapContext.state.mapView.map.add(newLayer);

    // Dispatch after layer creation attempt
    mapContext.dispatch({
      layerCreationLoading: false
    });
  }

  function buildRenderer(maxUsage, isNight = false) {
    const colors = isNight ? nightColors() : dayColors();

    const outline = { color: [178, 178, 178, 0.9], width: 0.7 };

    return {
      type: "class-breaks",
      field: "f_kiekis",
      classBreakInfos: [
        {
          minValue: 0,
          maxValue: maxUsage * 0.2,
          symbol: {
            type: "simple-fill",
            color: colors[0],
            outline
          },
          label: `0–${Math.round(maxUsage * 0.2)}`
        },
        {
          minValue: maxUsage * 0.2,
          maxValue: maxUsage * 0.4,
          symbol: {
            type: "simple-fill",
            color: colors[1],
            outline
          },
          label: `≤${Math.round(maxUsage * 0.4)}`
        },
        {
          minValue: maxUsage * 0.4,
          maxValue: maxUsage * 0.6,
          symbol: {
            type: "simple-fill",
            color: colors[2],
            outline
          },
          label: `≤${Math.round(maxUsage * 0.6)}`
        },
        {
          minValue: maxUsage * 0.6,
          maxValue: maxUsage * 0.8,
          symbol: {
            type: "simple-fill",
            color: colors[3],
            outline
          },
          label: `≤${Math.round(maxUsage * 0.8)}`
        },
        {
          minValue: maxUsage * 0.8,
          maxValue: maxUsage + 1,
          symbol: {
            type: "simple-fill",
            color: colors[4],
            outline
          },
          label: `> ${Math.round(maxUsage * 0.8)}`
        }
      ],
      defaultSymbol: {
        type: "simple-fill",
        color: [255, 255, 255, 0.2],
        outline
      }
    };
  }

  function buildLabelingInfo() {
    return [
      {
        labelExpressionInfo: {
          expression: "$feature.f_kiekis"
        },
        symbol: {
          type: "text",
          color: "black",
          haloColor: [255, 255, 255, 0.8],
          haloSize: 1,
          font: {
            size: 18,
            weight: "bold"
          }
        },
        labelPlacement: "center-center"
      }
    ];
  }

  function rebuildLayerFromGridData(gridData, mapView, existingLayer, setLayer, gridSelected = 0) {
  if (!gridData || gridData.length === 0) return;

    // Step 1: Compute max usage for color breaks
    const maxUsage = Math.max(...gridData.map((g) => g.usage || 0));

    // Step 2: Build graphics from gridData
    const graphics = gridData.map((grid, i) => {
      return new Graphic({
        geometry: grid.geometry,
        attributes: {
          ObjectID: i + 1,
          grid_id: grid.gridId,
          f_kiekis: grid.usage,
          f_sarasas1: "",
          f_sarasas2: "",
          f_sarasas3: "",
          f_sarasas4: ""
        }
      });
    });

    // Step 3: Create new FeatureLayer
    const newLayer = new FeatureLayer({
      source: graphics,
      objectIdField: "ObjectID",
      geometryType: "polygon",
      spatialReference: { wkid: 3857 },
      title: "Correlation Grid",
      fields: [
        { name: "ObjectID", type: "oid" },
        { name: "grid_id", type: "string" },
        { name: "f_kiekis", type: "integer" },
        { name: "f_sarasas1", type: "string" },
        { name: "f_sarasas2", type: "string" },
        { name: "f_sarasas3", type: "string" },
        { name: "f_sarasas4", type: "string" }
      ],
      renderer: buildRenderer(maxUsage, gridSelected === 1),
      labelingInfo: null
    });

    // Step 4: Replace existing layer on map and in state
    if (existingLayer) {
      mapView.map.remove(existingLayer);
    }

    mapView.map.add(newLayer);
    setLayer(newLayer);

    if (gridSelected === 0) {
        mapContext.dispatch({
          gridLegendData: ["Day", maxUsage ],
        });
      } else if (gridSelected === 1) {
        mapContext.dispatch({
          gridLegendData: ["Night", maxUsage ],
        });
      } else {
        mapContext.dispatch({
        gridLegendData: [mapContext.state.gridLegendData[0], maxUsage]
      });
    }
  }



  // apskaiciuojamas usage , paimamas orginaliai paspaustas grid'as ir suziurima pagal jo f_saras'o propercius kiek atsikartoja tam tikru grid'u
  

  // nakties spalvu rgb
  function nightColors() {
    return [
      [87, 186, 250, 0.4],
      [61, 128, 205, 0.4],
      [101, 84, 174, 0.4],
      [63, 54, 158, 0.4],
      [46, 0, 93, 0.4],
    ];
  }

  // dienos spalvu rgb
  function dayColors() {
    return [
      [255, 255, 178, 0.4],
      [254, 204, 92, 0.4],
      [253, 141, 60, 0.4],
      [240, 59, 32, 0.4],
      [189, 0, 38, 0.4],
    ];
  }

  // pridedamas grafinis poligonas priklausomai pagal nakties ar dienos spalva ir usage/maxusage santyki
  function addGraphicPolygon(
    geometry,
    usage = 0,
    maxUsage = 0,
    gridId,
    clicked = 1
  ) {
    let fillColor = [255, 0, 0, 0.2];
    let outlineColor = [178, 178, 178, 0.9];
    let oulineWidth = 0.7;
    let fillColorArr;
    if (gridSelected === 1) {
      fillColorArr = nightColors();
    }
    if (gridSelected === 0) {
      fillColorArr = dayColors();
    }
    fillColor = fillColorArr[4];
    if (usage <= maxUsage * 0.8) {
      fillColor = fillColorArr[3];
    }
    if (usage <= maxUsage * 0.6) {
      fillColor = fillColorArr[2];
    }
    if (usage <= maxUsage * 0.4) {
      fillColor = fillColorArr[1];
    }
    if (usage <= maxUsage * 0.2) {
      fillColor = fillColorArr[0];
    }
    if (clicked === 1) {
      if (
        mapContext.state.gridClickData.graphic.attributes.grid_id === gridId
      ) {
        fillColor = [255, 255, 255, 0.2];
        outlineColor = [178, 178, 178, 0.9];
        oulineWidth = 0.7;
      }
    }

    let symbol = {
      type: "simple-fill",
      color: fillColor,
      style: "solid",
      outline: {
        color: outlineColor,
        width: oulineWidth,
      },
    };

    let graphic = new Graphic(geometry, symbol);
    graphicLayer.add(graphic);
  }

  // pridedamas tekstas kuris atvaizduoja usage
  function addGraphicText(geometry, text, visibility = true) {
    let textSymbol = {
      type: "text",
      color: "black",
      haloColor: [255, 255, 255, 0.8],
      haloSize: 1,
      text: text,
      xoffset: 0,
      yoffset: 0,
      font: {
        size: 18,
        weight: "bold",
      },
    };

    let graphic = new Graphic(geometry, textSymbol);
    graphic.visible = visibility;

    graphicLayer.add(graphic);
  }

  waitForElm(".SidebarGridCard").then((button) => {
    button.forEach((element) => {
      element.addEventListener("click", function () {
        button.forEach((nav) => nav.classList.remove("Active"));
        this.classList.add("Active");
      });
    });
  });

  waitForElm(".ButtonColor").then((button) => {
    button.forEach((element) => {
      element.addEventListener("click", function () {
        button.forEach((nav) => nav.classList.remove("Active"));
        this.classList.add("Active");
      });
    });
  });

  useEffect(() => {
    if (gridData.length === 0) {
      return;
    }
    graphicLayer.removeAll();

    // sukuriamas extento grafinis elementas po removeAll
    let symbol = {
      type: "simple-line", // autocasts as new SimpleLineSymbol()
      color: [232, 76, 49, 1],
      width: "4px",
      style: "solid",
    };
    var graphic = new Graphic(mapContext.state.extentGeometry, symbol);
    graphicLayer.add(graphic);

    let gridTextVisibility = true;

    if (mapContext.state.mapView.zoom < 14) {
      gridTextVisibility = false;
    }

    // isimama didziausia suskaicuota usage reiksme ir naudojama kaip maxValue
    let maxGridValue = Math.max(
      ...gridData.map((singleGrid) => singleGrid.usage)
    );

    // kiekvienam pasiekiamam gridui nubraizomas grafinis elementas ir tekstas
    hexGrid.visible = false;
    rebuildLayerFromGridData(
      gridData,
      mapContext.state.mapView,
      applicationFeatureLayer,
      setApplicationFeatureLayer,
      gridSelected
    );

    mapContext.dispatch({
      layerLoading: 0
    });
    return
    gridData.forEach((grid) => {
      //console.log("DRAW GRID 2");
      addGraphicText(grid.geometry.centroid, grid.usage, gridTextVisibility);
      addGraphicPolygon(
        grid.geometry,
        grid.usage,
        maxGridValue,
        grid.gridId,
        1
      );
    });
    // orginaliai paspaustam griduo nubreziamas pilkas poligonas
    if (
      !gridData.find(
        (grid) =>
          grid.gridId ===
          mapContext.state.gridClickData.graphic.attributes.grid_id
      )
    ) {
      addGraphicPolygon(
        mapContext.state.gridClickData.graphic.geometry,
        0,
        maxGridValue,
        mapContext.state.gridClickData.graphic.attributes.grid_id,
        1
      );
    }

    mapContext.dispatch({
      layerLoading: 0,
    });
  }, [gridData]);

  useEffect(() => {
    if (initialRender === 0 || mapContext.state.gridClickData === null) {
      return
    }
    mapContext.dispatch({
      clearFlag: 1,
    });
  },[mapContext.state.dateRange])

  useEffect(() => {
    //console.log("LayerLOADING " + mapContext.state.layerLoading);
  }, [mapContext.state.layerLoading]);

  // pradiniai veiksmai sukuriamas layeris  kuris bus naudojamas grafiniams elementams, atrenkamos datos kurioms yra egzistuojanciu duomenu, suquerinami gridai (geometrijai ir id'am) ir sustorinami useState
  useEffect(() => {
    if (initialRender === 1) {
      return;
    }
    setInitialRender(1);

    let hexGraphicLayer = new GraphicsLayer();
    //console.log("hexGraphicLayer");
    hexGraphicLayer.title = "HexGraphic";
    //console.log(hexGraphicLayer);
    mapContext.state.mapView.map.add(hexGraphicLayer);
    createFeatureLayer()
    
    setGraphicLayer(hexGraphicLayer);

    uniqueValues({
      layer: dayLayer,
      field: "datetime",
    }).then(function (response) {
      // prints each unique value and the count of features containing that value
      //console.log(response);
      let infos = response.uniqueValueInfos;
      let availableDatesLocal = [];
      let parsedDates = [];
      infos.forEach(function (info) {

        if (!availableDatesLocal.includes(info.value)) {
          let addDate = new Date(info.value);
          parsedDates.push(addDate);
          availableDatesLocal.push(info.value);
        }
      });
      setCalendarDates(parsedDates);
    });

    let query = hexGrid.createQuery();
    query.where = "1=1";

    queryFeaturesOverLimit2k(hexGrid, query, mapContext).then((results) => {
      setGridObjArr(results);
    });
  }, [initialRender]);

  // ijungiamas / isjungiamas tekstas pagal zoom lygi
  useEffect(() => {
    //console.log(mapContext.state.mapView.graphics);
    //console.log(graphicLayer);
    //console.log(mapContext.state.mapView.zoom);
    //console.log(gridTextVisible);
    if (gridTextVisible === true && mapContext.state.mapView.zoom < 14) {
      graphicLayer.graphics.items.forEach((element) => {
        if (element.symbol.type === "text") {
          element.visible = false;
        }
      });
      setGridTextVisible(false);
    }
    if (gridTextVisible === false && mapContext.state.mapView.zoom >= 14) {
      graphicLayer.graphics.items.forEach((element) => {
        if (element.symbol.type === "text") {
          element.visible = true;
        }
      });
      setGridTextVisible(true);
    }
  }, [mapContext.state.mapView.zoom]);

  // paspaudus diena/naktis ir parinkus data, atvaizduojami gridai su ju usage kiekiu
  useEffect(() => {
    if (
      gridSelected === null ||
      mapContext.state.dateRange === null ||
      gridObjArr.length === 0 ||
      mapContext.state.gridClickData !== null
    ) {
      return;
    }
    graphicLayer.removeAll();
    let symbol = {
      type: "simple-line", // autocasts as new SimpleLineSymbol()
      color: [232, 76, 49, 1],
      width: "4px",
      style: "solid",
    };
    var graphic = new Graphic(mapContext.state.extentGeometry, symbol);
    graphicLayer.add(graphic);

    mapContext.dispatch({
      layerLoading: 2,
    });
    //console.log(gridObjArr);
    //console.log(gridObjArr.length);
    let queryTable;
    let queryAgainstTable;
    if (gridSelected === 1) {
      queryTable = nightLayer;
      queryAgainstTable = dayLayer;
    } else if (gridSelected === 0) {
      queryTable = dayLayer;
      queryAgainstTable = nightLayer;
    }

    let date = mapContext.state.dateRange;
      

    //console.log(date)
    let againstQuery = queryAgainstTable.createQuery();
    againstQuery.where = date;

    mapContext.dispatch({
      layerCreationLoading: true
    });
    // Paquerinami priesingo layerio tos dienos grid'ai
    queryFeaturesOverLimit2k(queryAgainstTable, againstQuery, mapContext).then((results) => {
      
    })
      


    let query = queryTable.createQuery();
    query.where =
      "datetime" + date.slice(8, 42) + " and datetime" + date.slice(55);
    // VN BUG grid_id = 'FG-96' and datetime >= timestamp'10/31/2024 23:59:59' and datetime < timestamp'11/01/2024 23:59:59'
    //console.log(queryTable);
    //console.log(query);
    queryFeaturesOverLimit2k(queryTable, query, mapContext).then((results) => {
      //console.log("Grid Results");
      populateFeatureLayerAttributes(results)
      
      const processed = results.map(grid => extractRelevantAttributes(grid));
      setAgainstGridObjArr(processed);

      var outputObj = results.reduce((finalObj, curObj) => {
        if (!finalObj[curObj.attributes.grid_id])
          finalObj[curObj.attributes.grid_id] = curObj.attributes.f_kiekis;
        //<--- adding new user if do not exist in the object
        else finalObj[curObj.attributes.grid_id] += curObj.attributes.f_kiekis; // <---- if already present, the add the sum
        return finalObj;
      }, {});

      var output = Object.entries(outputObj).map((obj) => ({
        gridId: obj[0], //<--- key of object as userId
        usage: obj[1], //<--- value of object as sum
      }));

      //console.log(output);

      let geometryGrids = gridObjArr.map((element) => {
        return {
          geometry: element.geometry,
          gridId: element.attributes.grid_id,
        };
      });

      //console.log(geometryGrids);

      // Subraizyti pagala output.gridId ir gridObjArr geometrija
      let mergedArrayGrid = mergeArrays(geometryGrids, output);
      //console.log(mergedArrayGrid);

      let itemsProccessed = 0;

      let gridTextVisibility = true;

      if (mapContext.state.mapView.zoom < 14) {
        gridTextVisibility = false;
      }

      let maxGridValue = Math.max(
        ...mergedArrayGrid.map((singleGrid) => singleGrid.usage)
      );
      mapContext.dispatch({
            layerLoading: 0,
      });
      return
      mergedArrayGrid.forEach((grid) => {
        //console.log("DRAW GRID");

        addGraphicText(grid.geometry.centroid, grid.usage, gridTextVisibility);
        addGraphicPolygon(
          grid.geometry,
          grid.usage,
          maxGridValue,
          grid.gridId,
          0
        );

        itemsProccessed++;
        if (itemsProccessed === mergedArrayGrid.length) {
          //console.log("Finished processing");
          mapContext.dispatch({
            layerLoading: 0,
          });
        }
      });
    });
  }, [gridObjArr, mapContext.state.dateRange, gridSelected]);

  // paspaudus ant grid'o su duomenim pradedamas procesas kur skaicuojamas jo atitinkamas pasiekiamumas nakciai/dienai
  useEffect(() => {
    if (
      gridSelected === null ||
      mapContext.state.dateRange === null ||
      mapContext.state.gridClickData === null ||
      mapContext.state.gridClickData.graphic.attributes.grid_id === undefined ||
      mapContext.state.gridClickData.graphic.attributes.grid_id === null
    ) {
      mapContext.dispatch({
        gridClickData: 0,
      });
      return;
    }

    //console.log("START LOADING");
    /*
    mapContext.dispatch({
      layerLoading: 2,
    });
    */
    setGridData([]);

    // paziurima ar paspausta diena ar naktis, querinamas priesingas table'as suzinoti pasiekiamus gridus
    let queryLayerClicked;
    let queryLayerResults;
    //
    if (gridSelected === 0) {
      queryLayerClicked = dayLayer;
      queryLayerResults = nightLayer;
    }
    if (gridSelected === 1) {
      queryLayerClicked = nightLayer;
      queryLayerResults = dayLayer;
    }
    //querinamas paspaustas gridas gauti f_sarasus
    let queryClikedGridIdsWhere =
      "grid_id = '" +
      mapContext.state.gridClickData.graphic.attributes.grid_id +
      "' and " +
      mapContext.state.dateRange;
    let query = queryLayerClicked.createQuery();
    query.where = queryClikedGridIdsWhere;
    //console.log(queryLayerClicked);
    //console.log(query);
    // Apkeiciau palyginus su tuo kas dabar live layeri
    queryFeaturesOverLimit2k(queryLayerResults, query, mapContext).then((results) => {
      try {
        //console.log(results);
        let gridUserIdArray = [];
        let element = results[0];
        gridUserIdArray = [
          ...element.attributes.f_sarasas1.split(","),
          ...gridUserIdArray,
        ];

        if (results[0].attributes.f_kiekis > 500) {
          results.forEach((element) => {
            gridUserIdArray = [
              ...element.attributes.f_sarasas2.split(","),
              ...gridUserIdArray,
            ];
          });
        }
        if (results[0].attributes.f_kiekis > 1000) {
          results.forEach((element) => {
            gridUserIdArray = [
              ...element.attributes.f_sarasas3.split(","),
              ...gridUserIdArray,
            ];
          });
        }
        if (results[0].attributes.f_kiekis > 1500) {
          results.forEach((element) => {
            gridUserIdArray = [
              ...element.attributes.f_sarasas4.split(","),
              ...gridUserIdArray,
            ];
          });
        }

        //console.log(gridUserIdArray);
        // leidziamas queris surinkti susijusius gridus pagal f_sarasa


        //console.log(gridUserIdArray)
        findMatchingGridsWithCounts(againstGridObjArr, gridUserIdArray)
        //console.log(matched)
      } catch (error) {
        console.error("Failed to process grid user ID array", error);
      }
    });

    // rekursivus queris surinkti visus gridus ir juos sustorinti gridData useState
    
  }, [mapContext.state.gridClickData, gridSelected]);

  async function findMatchingGridsWithCounts(againstGridObjArray, gridUserIdArray) {
    const clickedSet = new Set(gridUserIdArray);
    const results = [];

    //console.log(clickedSet)
    for (const gridObj of againstGridObjArray) {
      let matchCount = 0;
      //console.log(gridObj)

      for (const userID of gridObj.userIDs) {
        //console.log(userID)
        if (clickedSet.has(userID)) {
          //console.log("add 1")
          //console.log(gridObj.userIDs)
          //console.log(userID)
          matchCount++;
        }
      }

      if (matchCount > 0) {
        //console.log(gridObj.gridID, matchCount)
        results.push({
          gridId: gridObj.gridID,
          usage: matchCount,
          geometry: null,
        });
      }
    }

    let gridDataArray = [...(await getGridGeometry(results))];
    setGridData(gridDataArray);

    return gridDataArray;
  }


  function extractRelevantAttributes(feature) {

    return {
      gridID: feature.attributes.grid_id,
      userIDs : extractUserIDs(feature),
      geometry : null
    }
  }

  function extractUserIDs(feature) {
  return [feature.attributes.f_sarasas1, feature.attributes.f_sarasas2, feature.attributes.f_sarasas3, feature.attributes.f_sarasas4]
    .filter(Boolean)
    .join(',')
    .split(',')
    .map(s => s.trim())
    .filter(Boolean);
  }

  useEffect(() => {
    if (gridSelected !== null) {
      mapContext.dispatch({
        compareTask: 2,
      });
      mapContext.dispatch({
        selectedStreetArray: [1],
      });
      if (gridSelected === 0) {
        mapContext.dispatch({
          gridLegendData: ["Day", mapContext.state.gridLegendData[1] ],
        });
      } else if (gridSelected === 1) {
        mapContext.dispatch({
          gridLegendData: ["Night", mapContext.state.gridLegendData[1] ],
        });
      }
    }
    setGridData([]);
  }, [gridSelected]);

  useEffect(() => {
    graphicLayer.removeAll();
    graphicLayer.destroy();

    let hexGraphicLayer = new GraphicsLayer();
    hexGraphicLayer.title = "HexGraphic";
    mapContext.state.mapView.map.add(hexGraphicLayer);
    setGraphicLayer(hexGraphicLayer);

    hexGrid.visible = true;

    if (typeof window.gc === "function") {
      window.gc();
      //console.log("Garbage collection triggered.");
    } else {
      //console.log("Garbage collection not supported.");
    }

    mapContext.dispatch({
      selectedStreetArray: [],
    });
    mapContext.dispatch({
      compareDate: 0,
    });
    mapContext.dispatch({
      dateRange: 0,
    });
    mapContext.dispatch({
      calendarResetDates: 0,
    });
    mapContext.dispatch({
      gridLegendData: [0,0],
    });
    setGridSelected(null);
    mapContext.state.mapView.map.remove(applicationFeatureLayer);
    setApplicationFeatureLayer(initialFetureLayer);
    

    let elems = document.querySelectorAll(".GridSelection");

    [].forEach.call(elems, function (el) {
      el.classList.remove("Active");
    });

  }, [mapContext.state.clearFlag]);

  useEffect(() => {
    //console.log(gridToggleArr);
    if (gridSidebarSelection === 1) {
      for (let i = 0; i < gridToggleArr.length; i++) {
        if (gridToggleArr[i] === true) {
          let str = "gridToggle" + i;
          document.getElementById(str).click();
        }
      }
    }
  }, [gridSidebarSelection]);

  


  return (
    <>
      <div
        id={"CalendarSidebarBtn"}
        className={"SidebarGridCard Active"}
        onClick={() => {
          setGridSidebarSelection(0);
        }}
      >
        Kalendorius
      </div>
      <div
        id={"ContextSidebarBtn"}
        className={"SidebarGridCard"}
        onClick={() => {
          setGridSidebarSelection(1);
        }}
      >
        Kontekstiniai duomenys
      </div>
      <div id={"SidebarGrid"} className={"MenuColor"}>
        {gridSidebarSelection === 0 ? (
          <Calendar
            token={token}
            monthWeekDay={false}
            dispatcher={0}
            headerText={"Pasirinkite laikotarpį"}
            colorScheme={""}
            inlineBool={true}
            existingStartDate={
              mapContext.state.calendarResetDates === null
                ? null
                : mapContext.state.calendarResetDates[0]
            }
            existingEndDate={
              mapContext.state.calendarResetDates === null
                ? null
                : mapContext.state.calendarResetDates[1]
            }
            dataSource={calendarDates}
            canSelectRange={false}
          ></Calendar>
        ) : <ContextLayers></ContextLayers>}
        
      </div>
      {gridSidebarSelection === 0 /*&& mapContext.state.dateRange !== null */? <LegendGrid/> : <></>}
      <div id={"MenuGrid"} className={"MenuColor"}>
        <div
          id={"DayGrid"}
          className={"ButtonColor GridSelection"}
          onClick={() => {
            setGridSelected(0);
          }}
        >
          <img
            className={"GridIconImg"}
            src={gridSelected === 0 ? dayActive : dayInactive}
            alt="day"
          ></img>
        </div>
        <div
          id={"NightGrid"}
          className={"ButtonColor GridSelection"}
          onClick={() => {
            setGridSelected(1);
          }}
        >
          <img
            className={"GridIconImg"}
            src={gridSelected === 1 ? nightActive : nightInactive}
            alt="night"
          ></img>
        </div>
      </div>
    </>
  );
}
